module.exports = __webpack_public_path__ + "img/newspapers_button_big_up.ac17fa25.png";